// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__searchPanel":"qt_a bhu_rq bhu_kr bhu_ks","PostDetailRight__brandDaysPosts":"qt_b bhu_rq bhu_kr bhu_ks"};